import Client from './Client';
import { User } from '../models';


const LOGIN_PATH       = '/kuser/login';
const REGISTER_PATH    = '/kuser/register';
const SPOOF_PATH       = '/kuser/spoof';
const LOGOUT_PATH      = '/kuser/logout';
const GET_PROFILE_PATH = '/kuser/profile';

class Auth extends Client {
    checkApiKey(apiKey) {
        return this.GET(GET_PROFILE_PATH, {}, {
            "X-API-Key": apiKey
        })
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    const { tickets, ...rest } = json.user;
                    localStorage.setItem('user', JSON.stringify(rest));
                    return new User(rest);
                }
                return null;
            });
    }

    logIn(email, password) {
        return this.POST(LOGIN_PATH, {
            email,
            password
        })
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    const { tickets, ...rest } = json.user;
                    localStorage.setItem('user', JSON.stringify(rest));
                    json.user = new User(rest);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    register(payload) {
        return this.POST(REGISTER_PATH, payload)
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    const { tickets, ...rest } = json.user;
                    localStorage.setItem('user', JSON.stringify(rest));
                    json.user = new User(rest);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    spoof(id) {
        return this.POST(SPOOF_PATH, { id })
            .then(response => response.json())
            .then(json => {
                if (json.user) {
                    localStorage.setItem('user', JSON.stringify(json.user));
                    json.user = new User(json.user);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    logOut() {
        return this.POST(LOGOUT_PATH).then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error("Déconnexion impossible");
        });
    }
}

const AuthApi = new Auth();

export default AuthApi;
